<template>
  <div class="card border-0 shadow-none rounded-1 mb-25">
    <div class="card-body p-xl-40">
      <div class="table-responsive style-three">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ps-0">
                DATE
                <img
                  class="ms-2"
                  src="../../../assets/img/icons/up-down-aroow.svg"
                  alt="Image"
                />
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0">
                REFERENCE
                <img
                  class="ms-2"
                  src="../../../assets/img/icons/up-down-aroow.svg"
                  alt="Image"
                />
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0">
                SALE
                <img
                  class="ms-2"
                  src="../../../assets/img/icons/up-down-aroow.svg"
                  alt="Image"
                />
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0">
                CUSTOMER
                <img
                  class="ms-2"
                  src="../../../assets/img/icons/up-down-aroow.svg"
                  alt="Image"
                />
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0">
                PAID BY
                <img
                  class="ms-2"
                  src="../../../assets/img/icons/up-down-aroow.svg"
                  alt="Image"
                />
              </th>
              <th
                scope="col"
                class="text-title fw-normal fs-14 pt-0 text-end pe-0"
              >
                AMOUNT
                <img
                  class="ms-2"
                  src="../../../assets/img/icons/up-down-aroow.svg"
                  alt="Image"
                />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="shadow-none fw-normal text-black title ps-0">
                <span class="text-optional fs-14">26/09/2023</span>
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                5389607
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                S - 2234
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                Jane Ronan
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                Cash
              </td>
              <td
                class="shadow-none lh-1 fs-14 fw-semibold text-paragraph text-end"
              >
                $120.00
              </td>
            </tr>
            <tr>
              <td class="shadow-none fw-normal text-black title ps-0">
                <span class="text-optional fs-14">25/09/2023</span>
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                5389607
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                S - 2234
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                Victor James
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                Cash
              </td>
              <td
                class="shadow-none lh-1 fs-14 fw-semibold text-paragraph text-end"
              >
                $2100.00
              </td>
            </tr>
            <tr>
              <td class="shadow-none fw-normal text-black title ps-0">
                <span class="text-optional fs-14">24/09/2023</span>
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                5389607
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                S - 2234
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                Anda Smith
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                Cash
              </td>
              <td
                class="shadow-none lh-1 fs-14 fw-semibold text-paragraph text-end"
              >
                $1210.00
              </td>
            </tr>
            <tr>
              <td class="shadow-none fw-normal text-black title ps-0">
                <span class="text-optional fs-14">23/09/2023</span>
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                5389607
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                S - 2234
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                Jennifer Lora
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                Cash
              </td>
              <td
                class="shadow-none lh-1 fs-14 fw-semibold text-paragraph text-end"
              >
                $1500.00
              </td>
            </tr>
            <tr>
              <td class="shadow-none fw-normal text-black title ps-0">
                <span class="text-optional fs-14">21/09/2023</span>
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                5389607
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                S - 2234
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                Angela Carter
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                Cash
              </td>
              <td
                class="shadow-none lh-1 fs-14 fw-semibold text-paragraph text-end"
              >
                $1000.00
              </td>
            </tr>
            <tr>
              <td class="shadow-none fw-normal text-black title ps-0">
                <span class="text-optional fs-14">19/09/2023</span>
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                5389607
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                S - 2234
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                Jonathon Ronan
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                Cash
              </td>
              <td
                class="shadow-none lh-1 fs-14 fw-semibold text-paragraph text-end"
              >
                $15300.00
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="row pb-45 align-items-center">
    <div class="col-sm-6">
      <div
        class="d-flex flex-wrap align-items-center justify-content-center justify-content-sm-start page-unit"
      >
        <span class="fs-13">Showing product per page</span>
        <select class="text-title border-0 fs-14 bg-transparent">
          <option value="0">10</option>
          <option value="1">20</option>
          <option value="2">30</option>
        </select>
      </div>
    </div>
    <div class="col-sm-6 text-sm-end text-center">
      <ul class="page-nav list-style">
        <li>
          <a href="#">
            <img
              src="../../../assets/img/icons/left-arrow-purple.svg"
              alt="Image"
            />
          </a>
        </li>
        <li><a href="#" class="active">1</a></li>
        <li><a href="#">2</a></li>
        <li><a href="#">3</a></li>
        <li>
          <a href="#">
            <img
              src="../../../assets/img/icons/right-arrow-purple.svg"
              alt="Image"
            />
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "SalesPaymentReport",
};
</script>